import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionReadyToSharePreviewLinkQuery,
	PetitionReadyToSharePreviewLinkQueryVariables,
} from './getPetitionReadyToSharePreviewLink.graphql';
import { PetitionReadyToSharePreviewLink } from './getPetitionReadyToSharePreviewLink.graphql';

type ReadyToSharePreviewLinkResult = NonNullable<
	PetitionReadyToSharePreviewLinkQuery['petitionBySlugOrId']
>['readyToSharePreviewLink'];

export type ReadyToSharePreviewLinkDetails = Extract<
	ReadyToSharePreviewLinkResult,
	{ __typename: 'ReadyToSharePreviewLinkSuccess' }
>['previewLink'];

export async function getPetitionReadyToSharePreviewLink(
	slugOrId: string,
	{ gql: { fetch }, errorReporter }: UtilityContext,
	previewId: string,
): Promise<ReadyToSharePreviewLinkDetails | null> {
	const { data, requestId } = await fetch<
		PetitionReadyToSharePreviewLinkQuery,
		PetitionReadyToSharePreviewLinkQueryVariables
	>({
		query: PetitionReadyToSharePreviewLink,
		variables: { slugOrId, previewId },
		rejectOnError: true,
	});

	const result = data.petitionBySlugOrId?.readyToSharePreviewLink;

	if (result?.__typename === 'ReadyToSharePreviewLinkSuccess') {
		return result.previewLink;
	}

	if (result?.__typename === 'ReadyToSharePreviewLinkFailure' && result.error === 'UNEXPECTED_ERROR') {
		void errorReporter.report({
			error: new Error('Failed to fetch Ready to Share preview link'),
			context: {
				requestId,
				feature: 'share_for_starters',
				'gql.operation': 'PetitionReadyToSharePreviewLink',
				'failure.reason': result.error,
			},
			params: { slugOrId, previewId },
		});
	}

	return null;
}
